/**
 * Which of the sheet's context-specific actions to show. They used to sit
 * behind an overflow menu; with only two of them, the menu hid them for
 * nothing, so they now sit on the sheet itself — Share beside the close button
 * and "View in 3D" in the circular row. Pure, so the rules are testable without
 * mounting the sheet.
 */

export interface SheetActionContext {
  /** The POI's type (`peak`, `water`, …), or '' before it has loaded. */
  type: string;
  /** The backend answered POI_DELETED: the sheet shows only the name. */
  removed: boolean;
  /** Pinned on the 3D peak page rather than opened over a map. */
  pinned: boolean;
  /** The POI's own link (see poiSharing), or null when there is none. */
  shareUrl: string | null;
}

/**
 * Peaks only, and never on the 3D page itself, where the button would reopen
 * the page the walker is already on.
 */
export function showsViewIn3D({ type, removed, pinned }: SheetActionContext): boolean {
  return type === 'peak' && !removed && !pinned;
}

/** Whenever there is a link to hand over — a removed POI has none worth sharing. */
export function showsShare({ removed, shareUrl }: SheetActionContext): boolean {
  return !removed && !!shareUrl;
}
